import React, { useEffect, useState } from "react";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "../../../../StyleSheet/MainComponent/UDSEMployee/LeaveApply.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import fileUpload from "../../../../Assets/MainComponent/fileUpload.svg";
import {
  SetCreateLeaveAction,
  SetCalendarActions,
  SetLeaveTypeDataActions,
  setTheLeaveApplyDateUDS_employee,
} from "../../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
// import Button from "../../../AppComponent/Button/Button";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import dateFormat, { masks } from "dateformat";
import { Modal, Button } from 'react-bootstrap';
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";



function LeaveApplyUDS(props) {
  const { show, setshow } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const leaveTypes = useSelector((state) => state.LeaveTypeData.LeaveTypeData);
  const userId = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
  );
  const createLeave = useSelector(
    (state) => state.CreateLeaveCall.createLeaveData
  );

  const calendarResponse = useSelector(
    (state) => state.CalendarCall.CalendarData.data
  );

  // const currentYear = new Date().getFullYear();

  // const maxDate = new Date(currentYear, 11, 31); // December 31 of the current year
  // const minDate = new Date(currentYear, 0, 1); // January 1 of the current year

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const minDate = new Date(currentYear, currentMonth, 1); // First day of the current month
  const maxDate = new Date(currentYear, currentMonth + 1, 0); // Last day of the current month

  const state = useSelector((state) => state);
  const leaveTypeOptions = leaveTypes.map((item) => ({
    value: item.id,
    label: item.leave_type,
  }));
  leaveTypeOptions.unshift({
    value: "",
    label: "Select type of leave",
    isDisabled: true,
  });

  const [selectedDates, setSelectedDates] = useState([]);
  const [nonSelectableDates, setNonSelectableDates] = useState([]);

  useEffect(() => {
    const currentDate = new Date();
    const payload = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
    };
    dispatch(SetCalendarActions(payload));
  }, []);

  
  var applying = [state.UDSemployeeRoleActions.LeaveApplyedDate];
  useEffect(() => {
    if (calendarResponse != undefined && calendarResponse != null) {
      const dates = [];

      calendarResponse.map((item) => {
        console.log(item.date, "76iiututiiuiu");

        if (item.present) {
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.weekoff) {
          console.log(item, "2384238oln d");
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.working) {
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.leave) {
          dates.push({ fromdata: item.date, todate: null });
        }
      });
      state.UDSemployeeRoleActions.LeaveApplyedDate.map((item) => {
        dates.push({ fromdata: item.fromdata, todate: item.todate });
      });

      dispatch(setTheLeaveApplyDateUDS_employee(dates)); /// here update the actions
    }
  }, []);

  useEffect(() => {
    const dates = state.UDSemployeeRoleActions.LeaveApplyedDate.flatMap(
      (item) => {
        const datesArray = [];
        if (item.fromdata) {
          datesArray.push(new Date(item.fromdata));
        }
        if (item.todate) {
          datesArray.push(new Date(item.todate));
        }
        return datesArray;
      }
    );

    setNonSelectableDates(dates);
  }, [state]);

  const onChange = (date) => {
    const dateString = date.toDateString();
    fieldErrors.from_date = "";
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === dateString
      )
    ) {
      // If the date is already selected, remove it from the array
      setSelectedDates(
        selectedDates.filter(
          (selectedDate) => selectedDate.toDateString() !== dateString
        )
      );
    } else {
      // If the date is not selected, add it to the array
      setSelectedDates([...selectedDates, date]);
    }
  };

  const tileClassName = ({ date, view }) => {
    // Add class to selected dates
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString()
      )
    ) {
      return "highlight";
    }
    return null;
  };

  const tileDisabled = ({ date, view }) => {
    // Check if the current date is in nonSelectableDates
    return nonSelectableDates.some(
      (item) => item.toDateString() === date.toDateString()
    );
  };

  const [data, setData] = useState({
    continue_leave: false,
    from_date: "",
    to_date: "",
    status: "pending",
    notes: "",
    user_id: "",
    request_type: "request",
    leave_type: "",
  });
  const [fieldErrors, setFieldErrors] = useState({
    from_date: "",
    to_date: "",
    notes: "",
    leave_type: "",
  });
  const [selectedLeave, setSelectedLeave] = useState({});
  console.log(selectedDates, "selectedDates");
  const processedDates = selectedDates.map((date, index) => {
    if (index % 2 === 0) {
      return { type: "from", date }; // Even index, treat as 'from date'
    } else {
      return { type: "to", date }; // Odd index, treat as 'to date'
    }
  });

  function formatDateFields(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const [StateDate, setStateDate] = useState([]);
  const [fromDate, setFromdate] = useState({ from_date: "", to_date: "" });
  useEffect(() => {
    // Example usage:
    var Finaldate = [];

    if (selectedDates != null && selectedDates.length > 0) {
      selectedDates.map((item) => {
        const date = new Date(item);
        var formattedDate = formatDateFields(date);
        Finaldate.push({ value: formattedDate });
      });
      setStateDate(Finaldate);
    }
  }, [selectedDates]);

  useEffect(() => {
    if (StateDate) {
      const datesObject = {};

      if (StateDate.length == 2 || StateDate.length > 2) {
        // Sort StateDate by value (assuming StateDate is an array of objects with a 'value' property)
        StateDate.sort((a, b) => a.value.localeCompare(b.value));

        // Set from_date to the first value in sorted StateDate
        setFromdate({
          ...fromDate,
          // from_date: StateDate[0].value,
          // to_date: StateDate[StateDate.length - 1].value,

          from_date: StateDate[StateDate.length - 1].value,
          to_date: StateDate[0].value,
        });
      } else if (StateDate.length == 1) {
        // Handle case where StateDate is empty
        setFromdate({
          ...fromDate,
          from_date: StateDate[0].value, // Set default value for from_date when StateDate is empty
          to_date: null, // Set default value for to_date when StateDate is empty
        });
      }
    }
  }, [StateDate]);

  const handleSubmit = (e) => {
    // console.log("lkaslfjjasfk");
    e.preventDefault();

    const newFieldErrors = { ...fieldErrors };
    if (fromDate.from_date == "") {
      newFieldErrors.from_date = "From date must not be empty.";
    }
    if (fromDate.from_date != "") {
      newFieldErrors.from_date = "";
    }

    Object.entries(data).forEach(([key, value]) => {
      if (key === "notes" && value.trim().length === 0) {
        newFieldErrors.notes = "Notes must not be empty.";
      } else if (key === "leave_type" && value.trim().length === 0) {
        newFieldErrors.leave_type = "Leave type must not be empty.";
      }

      // else if (key === "continue_leave") {
      //   if (value) {
      //     if (data.from_date.trim().length === 0) {
      //       newFieldErrors.from_date = "From date must not be empty.";
      //     }
      //     if (data.to_date.trim().length === 0) {
      //       newFieldErrors.to_date = "To date must not be empty.";
      //     }
      //   } else {
      //     if (data.from_date.trim().length === 0) {
      //       newFieldErrors.from_date = "From date must not be empty.";
      //     }
      //   }
      // }
    });
    const hasError = Object.values(newFieldErrors).some((error) => error);
    setFieldErrors(newFieldErrors);
    if (!hasError) {
      console.log("No errors. Submitting form...");
      const formData = new FormData();
      formData.append(
        "data",
        JSON.stringify({
          continue_leave: data.continue_leave,
          // from_date: data.from_date,
          // to_date: data.to_date == "" ? null : data.to_date,
          to_date: fromDate.to_date,
          from_date: fromDate.from_date,
          status: data.status,
          notes: data.notes,
          user_id: data.user_id,
          request_type: data.request_type,
          leave_type: data.leave_type,
        })
      );
      const payload = {
        formData: {
          continue_leave: data.continue_leave,
          // from_date: data.from_date,
          // to_date: data.to_date == "" ? null : data.to_date,
          to_date: fromDate.to_date,
          from_date: fromDate.from_date,
          status: data.status,
          notes: data.notes,
          user_id: data.user_id,
          request_type: data.request_type,
          leave_type: data.leave_type,
        },
        post: 1,
      };
      dispatch(SetCreateLeaveAction(payload));
    }
  };

  useEffect(() => {
    if (userId !== undefined) {
      setData((prev) => ({
        ...prev,
        user_id: userId,
      }));
    }
  }, [userId]);
  // useEffect(() => {
  //   navigate("/leave");
  // }, [createLeave]);
  useEffect(() => {
    dispatch(SetLeaveTypeDataActions());
  }, []);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleDate = (inputDate, name) => {
    const value = formatDate(inputDate);
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  return (
    <>

      <Modal show={show} centered>
        <Modal.Header  className="popHead">
          <Modal.Title>Leave Request
          </Modal.Title>
          <div className="CloseIcon" onClick={(e) => setshow(false)}>
            <CloseOutlinedIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div >

            <form onSubmit={handleSubmit}>
              <div className="leaveApplyBody">
                <div className="row LeaveAplyInEMPUDS">
                  <div className="col-sm-12 section1">
                    <label htmlFor="leaveType">
                      Leave Type<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={leaveTypeOptions[0]}
                      isSearchable={true}
                      id="leaveType"
                      options={leaveTypeOptions}
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          leave_type: e.value,
                        }));
                        setSelectedLeave((prev) => ({
                          ...prev,
                          leave_type: e.label,
                        }));

                        fieldErrors.leave_type = "";
                      }}
                    />

                    <div className="errorCheckBox">
                      {fieldErrors.leave_type && (
                        <>
                          {" "}
                          <span style={{ color: "red" }}>
                            * {fieldErrors.leave_type}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-12 CalendarViews ">
                    <label
                      className="col-12 p-0"
                      htmlFor="to_date"
                    >
                      You can also select from to date based
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <Calendar
                      onClickDay={onChange}
                      value={
                        selectedDates.length
                          ? selectedDates[selectedDates.length - 1]
                          : new Date()
                      }
                      tileClassName={tileClassName}
                      tileDisabled={tileDisabled}
                      maxDate={maxDate}
                      minDate={minDate}
                    />
                  </div>

                  {fieldErrors.from_date && (
                    <>
                      {" "}
                      <span style={{ color: "red", marginLeft: "20px" }}>
                        {fieldErrors.from_date}
                      </span>
                    </>
                  )}
                  <div className="col-sm-12 section1">
                    <label
                      className=" p-0"
                      htmlFor="notes"
                      style={{ color: "#234492", margin: "0" }}
                    >
                      Notes<span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      style={{ width: "100%", height: "200px" , padding:"20px"}}
                      value={data.notes}
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          notes: e.target.value,
                        }));
                        fieldErrors.notes = "";
                      }}
                    ></textarea>
                    {fieldErrors.notes && (
                      <>
                        {" "}
                        <span style={{ color: "red" }}>
                          * {fieldErrors.notes}
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <>






                  {/* {selectedLeave.leaveType == "Medical Leave" && (
                <>
                  {selectedImage ? (
                    <div className="row d-flex justify-content-start">
                      <div className="col-xl-6 col-md-12 medicalImageWrapper">
                        <div className="medicalImageSection">
                        
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="white"
                            class="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                              fill-rule="evenodd"
                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                          </svg>
                          <input type="file" onChange={handleFileSelect} />
                        </div>
                        <img
                          src={URL?.createObjectURL(selectedImage)}
                          alt="Selected"
                          style={{ width: "200px", height: "200px" }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="row medicalWrapper">
                      <div className="col-xl-6 col-md-12 medicalSection">
                        <label htmlFor="leaveType">
                          Upload Medical Certificate
                        </label>
                        <div className="fileUploadImg">
                          <img
                            src={fileUpload}
                            alt="fileUpload"
                            width={"40px"}
                            height={"40px"}
                          />
                        </div>

                        <input type="file" onChange={handleFileSelect} />
                      </div>
                    </div>
                  )}
                </>
              )} */}


                </>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="RoleButton">

            <button
              className="customButton ButtonCSS"
              style={{ background: "#234492 " }}
              onClick={(e) => {
                setshow(false);
              }}
              type="submit"
            >
              Cancel
            </button>
            <button
              className="customButton ButtonCSS"
              style={{ background: "#234492 " }}
              onClick={handleSubmit}
              type="submit"
            >
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LeaveApplyUDS;
